<div class="wrapper">
    <div class="input-wrapper">
        <div>
            <label for="partnerId">Access code : </label>
            <p-dropdown 
                appendTo="body"
                [autoDisplayFirst]="false"
                [options]="accessCodes" 
                [(ngModel)]="config.accessCodeId" 
                optionLabel="name" 
                optionValue="id"></p-dropdown>
        </div>
        <div>
            <label for="partnerName">Product code : </label>
            <p-inputMask
                mask="9999-99-9"
                class="table-input"
                (onComplete)="onProductCodeCompleted()"
                (onInput)="onProductCodeInputed()"
                [(ngModel)]="config.productCode"></p-inputMask>
        </div>
    </div>
    <div class="button-wrapper">
        <button
            pButton
            label="Cancel"
            (click)="onCancelClicked()"
            class="p-button-danger"
        ></button>
        <button
            pButton
            label="Save"
            [disabled]="!config.accessCodeId || !completedProductCode"
            (click)="onSaveClicked()"
        ></button>
    </div>
</div>